import { render, staticRenderFns } from "./Season.vue?vue&type=template&id=010da5f2&scoped=true&"
import script from "./Season.vue?vue&type=script&lang=js&"
export * from "./Season.vue?vue&type=script&lang=js&"
import style0 from "./Season.vue?vue&type=style&index=0&id=010da5f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010da5f2",
  null
  
)

export default component.exports